"use client";
import { ChevronLeft } from "lucide-react";
import { Button } from "@/app/components/shadcn/button";
import SearchInput, { SearchInputProps } from "./SearchInput";
import SearchDropdownContent from "./SearchDropdownContent";
import { useMountTransition } from "@/app/hooks/useMountTransition";

interface SearchMobileSheetProps {
  onClose: () => void;
  inputProps: Omit<SearchInputProps, "autoFocus" | "onFocus">;
  query?: string;
  onSelect?: (term: string) => void;
  isOpen: boolean;
}

const SearchMobileSheet = ({
  onClose,
  inputProps,
  query = "",
  onSelect = () => {},
  isOpen,
}: SearchMobileSheetProps) => {
  const { rendered, isVisible } = useMountTransition(isOpen, 280);
  if (!rendered) return null;

  return (
    <div
      className="fixed md:hidden inset-0 z-[9999] backdrop-blur-sm"
      style={{
        backgroundColor: isVisible ? "rgba(0,0,0,0.2)" : "rgba(0,0,0,0)",
        transition: "background-color 200ms ease",
      }}
      onClick={onClose}
    >
      <div
        className="absolute top-0 left-0 right-0 bg-white h-full shadow-lg p-4 overflow-y-auto"
        style={{
          transform: isVisible ? "translateY(0)" : "translateY(-100%)",
          transition: "transform 280ms cubic-bezier(0.25, 0.46, 0.45, 0.94)",
          willChange: "transform",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center gap-3 mb-4 sticky top-0 bg-white pb-3 border-b border-gray-100">
          <Button onClick={onClose} size="icon-sm" variant="ghost">
            <ChevronLeft size={26} />
          </Button>
          <div className="flex-1">
            <SearchInput {...inputProps} autoFocus />
          </div>
        </div>
        <div className="space-y-6">
          <SearchDropdownContent
            onClose={onClose}
            query={query}
            onSelect={onSelect}
          />
        </div>
      </div>
    </div>
  );
};

export default SearchMobileSheet;